<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">Process Import Timesheet</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <div>
            <form *ngIf="!isProcessed" [formGroup]="processForm2" class="col-12">
                <div class="row">
                    <mat-form-field class="col-6" appearance="outline">
                        <mat-label>Select Payroll</mat-label>
                        <mat-select formControlName="payroll" (selectionChange)="onPayrollChange($event)"
                            (openedChange)="onPayrollDropdownOpenChange($event)" [ngModelOptions]="{standalone: true}">
                            <mat-select-trigger>
                                {{ getPayrollName(selectedPayroll) || 'Select Payroll' }}
                            </mat-select-trigger>
                            <mat-option class="search-option">
                                <input #payrollSearchInput [(ngModel)]="payrollSearchText"
                                    (ngModelChange)="filterPayrolls()" (click)="$event.stopPropagation()"
                                    placeholder="Search payrolls..." class="client-search-input"
                                    [ngModelOptions]="{standalone: true}">
                            </mat-option>
                            <mat-option *ngFor="let payroll of filteredPayrolls" [value]="payroll.hrpayrollID">
                                {{ payroll.payrollType }}
                            </mat-option>
                            <mat-option *ngIf="filteredPayrolls.length === 0" disabled>
                                <em>No payrolls found</em>
                            </mat-option>
                        </mat-select>
                        <span matSuffix class="material-icons">payment</span>
                    </mat-form-field>
                    <mat-form-field class="col-6" appearance="outline">
                        <mat-label>Select Period</mat-label>
                        <mat-select formControlName="period" (selectionChange)="onPeriodChange($event)"
                            (openedChange)="onPeriodDropdownOpenChange($event)" [ngModelOptions]="{standalone: true}"
                            [disabled]="!selectedPayroll">
                            <mat-select-trigger>
                                {{ getPeriodName(selectedPeriod) || 'Select Period' }}
                            </mat-select-trigger>
                            <mat-option class="search-option">
                                <input #periodSearchInput [(ngModel)]="periodSearchText"
                                    (ngModelChange)="filterPeriods()" (click)="$event.stopPropagation()"
                                    placeholder="Search periods..." class="client-search-input"
                                    [ngModelOptions]="{standalone: true}">
                            </mat-option>
                            <mat-option *ngFor="let period of filteredPeriods" [value]="period.hrperiodID">
                                {{ period.payrollName }}
                            </mat-option>
                            <mat-option *ngIf="filteredPeriods.length === 0" disabled>
                                <em>No periods found</em>
                            </mat-option>
                        </mat-select>
                        <span matSuffix class="material-icons">date_range</span>
                    </mat-form-field>
                </div>
                <div class="row">
                    <div class="col-12 mb-2">
                        <mat-checkbox formControlName="exclude" [ngModelOptions]="{standalone: true}">
                            Exclude Seconds
                        </mat-checkbox>
                    </div>
                </div>
            </form>
            <div *ngIf="isProcessed" class="w-100 mt-1">
                <div class="message-container">
                    <pre>{{ message }}</pre>
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-0 text-right">
        <button mat-button class="cancel-button" (click)="onNoClick()">Close</button>
        <div *ngIf="!isProcessed">
            <button mat-button class="yes-button" cdkFocusInitial (click)="onSubmit()"
                *ngIf="!isLoading; else loadingTemplate">Submit</button>
            <ng-template #loadingTemplate>
                <button mat-button type="button" class="yes-button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
            </ng-template>
        </div>
    </div>
</div>